import { render } from "./DetailsCarteDepartement.vue?vue&type=template&id=a5201e22"
import script from "./DetailsCarteDepartement.vue?vue&type=script&lang=js"
export * from "./DetailsCarteDepartement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__